<template>
    <div class="photo">
        <div class="bgBlueF3 px-38 pb-30 mb-30">
            <p>暂无</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>

<style lang="scss" scoped>
.photo{
    
}
</style>